import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { reviewsData } from '../../utils/reviewsData';
import { LandingTrans } from '../../utils/translations';

export default function TestimonialStrip() {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const list = reviewsData[language]?.length ? reviewsData[language] : reviewsData.russian;
  const [currentIndex, setCurrentIndex] = useState(0);
  const review = list[currentIndex];

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? list.length - 1 : prev - 1));
  };
  const goNext = () => {
    setCurrentIndex((prev) => (prev === list.length - 1 ? 0 : prev + 1));
  };

  if (!review) return null;

  return (
    <section className="w-full py-12 md:py-16 px-6 md:px-20 relative bg-brown">
      <div className="flex flex-col gap-10 md:gap-8 items-center max-w-6xl mx-auto">
        <button
          type="button"
          onClick={goPrev}
          className="hidden md:block absolute left-2 md:left-4 top-1/2 -translate-y-1/2 p-2 text-white/70 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-clay-light focus:ring-offset-2 focus:ring-offset-brown rounded"
          aria-label={t.prevReview}
        >
          <ChevronLeft size={32} strokeWidth={1.5} />
        </button>
        <button
          type="button"
          onClick={goNext}
          className="hidden md:block absolute right-2 md:right-4 top-1/2 -translate-y-1/2 p-2 text-white/70 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-clay-light focus:ring-offset-2 focus:ring-offset-brown rounded"
          aria-label={t.nextReview}
        >
          <ChevronRight size={32} strokeWidth={1.5} />
        </button>

        <blockquote className="relative flex-1 w-full md:px-12">
          <span
            className="font-serif text-clay-light absolute -top-2 -left-1 select-none"
            style={{ fontSize: 60 }}
            aria-hidden
          >
            "
          </span>
          <p
            className="font-serif text-white text-xl md:text-2xl italic leading-relaxed pl-8"
            style={{ lineHeight: 1.6 }}
          >
            {review.text}
          </p>
        </blockquote>

        <div className="flex flex-col items-center gap-2 w-full md:mt-0">
          <p className="text-sm font-sans text-white/90">— {review.name}</p>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={goPrev}
              className="p-1 text-white/70 hover:text-white md:hidden"
              aria-label={t.prevReview}
            >
              <ChevronLeft size={20} />
            </button>
            <div className="flex gap-1.5" role="tablist" aria-label={t.reviews}>
              {list.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => setCurrentIndex(index)}
                  className={`w-1.5 h-1.5 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-clay-light focus:ring-offset-2 focus:ring-offset-brown ${index === currentIndex ? 'bg-clay-light' : 'bg-white/50 hover:bg-white/70'}`}
                  aria-label={`${t.reviewOf}${index + 1}`}
                  aria-selected={index === currentIndex}
                />
              ))}
            </div>
            <button
              type="button"
              onClick={goNext}
              className="p-1 text-white/70 hover:text-white md:hidden"
              aria-label={t.nextReview}
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
